import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import VM from 'scratch-vm';
import VMScratchBlocks from '../lib/blocks';
import { connect } from 'react-redux';
import {
    runPythonFalse,
    runPythonTrue,
    runCTrue,
    runCFalse
} from '../reducers/btn-list';
import analytics from '../lib/analytics';
import ScratchBlocks from 'scratch-blocks';

import BtnlistComponent from '../components/btnList-debug/btn-list.jsx';

class Btnlist extends React.Component {
    constructor(props) {
        super(props);
        this.ScratchBlocks = VMScratchBlocks(this.props.vm);
        this.state = {
            show: false,
            M5_download_show: false
        }
        bindAll(this, [
            'handleGreenFlagClick',
            'handleStopAllClick',
            'handleDebugPythonClick',
            'handleDebugCClick',
            'handleDefaultDownloadClick',
            'handleDownloadPythonClick',
            'handleDownloadCClick',
            'setDownloadType',
            'handleSendPyCodeToWindowClick',
            'handleSendDebugToastToUnity',
            'handleSendBackToastToUnity',
            'handleBackSaveToastToUnity',
            'handleShowModal',
            'handleDownloadDesk',
            'handleM5ShowModal',
            'handleM5Download'
        ]);
    }

    // gui官方绿色旗帜运行 
    handleGreenFlagClick(e) {
        e.preventDefault();
        if (e.shiftKey) {
            this.props.vm.setTurboMode(!this.props.turbo);
        } else {
            if (!this.props.isStarted) {
                this.props.vm.start();
            }
            this.props.vm.greenFlag();
            analytics.event({
                category: 'general',
                action: 'Green Flag'
            });
        }
    }

    // 停止  python调试  c调试  
    handleStopAllClick(e, type) {
        e.preventDefault();
        if (this.props.defaultType == 'E7') {
            this.props.vm.stopE7Debug();
            return
        }
        this.props.vm.stopAll(type);
    }
    handleDebugPythonClick(type, e) {
        e.preventDefault();
        if (this.props.defaultType == 'E7') {
            this.props.vm.debugProjectJsonTcp()
            return
        }
        if (this.props.defaultType == 'M5') {
            this.props.vm.M5_start();
            return
        }
        this.props.vm.debugProjectJson();
    }
    handleDebugCClick(type, e) {
        e.preventDefault();
        this.props.onSetRunningStatus(type, true);
        this.props.vm.onRunC();
    }

    // python下载 c下载
    handleDownloadPythonClick(e) {
        if (this.props.isCorrect) {

            downloadAlert({
                show: true,
                type: 'Error',
                content: ScratchBlocks.Msg["gui.menuBar.fileFormatError"],
                animation: true,
                duration: 2000
            })
            return
        }
        if (this.props.defaultType == 'M5') {
            this.handleM5ShowModal()
            return
        }
        if (this.props.defaultType == 'E7') {
            this.props.vm.downProjectJsonTcp()
            return
        }
        if (this.props.defaultType == 'STORM_OS') {
            console.log('STORM_OS下载')
            this.props.vm.STORM_OS_DownloadPython();
            return
        }
        this.setDownloadType('python')
        // this.handleStopAllClick(e, 'all')
        this.props.vm.downProjectJson()
    }
    handleDownloadCClick(e) {

        if (this.props.isCorrect) {

            downloadAlert({
                show: true,
                type: 'Error',
                content: ScratchBlocks.Msg["gui.menuBar.fileFormatError"],
                animation: true,
                duration: 2000
            })
            return
        }

        if (this.props.defaultType == 'E7') {
            this.props.vm.downloadCTcp()
            return
        }
        this.setDownloadType('c')
        // this.handleStopAllClick(e, 'all')
        // 传递参数标明是USB下载还是蓝牙
        this.props.vm.downloadC(this.props.arg)
    }
    // 磁盘下载
    handleDownloadDesk() {
        if (this.props.isCorrect) {

            downloadAlert({
                show: true,
                type: 'Error',
                content: ScratchBlocks.Msg["gui.menuBar.fileFormatError"],
                animation: true,
                duration: 2000
            })
            return
        }
        this.setDownloadType('disk')
        this.props.vm.downloadDisk()
    }

    // 设置记录默认下载类型的本地缓存,M6和E6分开缓存。
    setDownloadType(type) {
        localStorage.setItem(this.props.defaultType + 'defaultDownloadType', type)
    }

    // 根据本地缓存判断默认下载c还是下载python
    handleDefaultDownloadClick(e) {
        let type = localStorage.getItem(this.props.defaultType + 'defaultDownloadType')
        if (type == null) {
            this.handleDownloadPythonClick(e)
        } else {
            if (type === 'python') {
                this.handleDownloadPythonClick(e)
            } else if (type === 'c') {
                this.handleDownloadCClick(e)
            } else if (type === 'disk') {
                this.handleDownloadDesk(e)
            }
        }
    }
    // 手机端专用下载按钮
    handleSendPyCodeToWindowClick() {
        let python = this.props.vm.getPythonByteArray();
        window.pythoncodeArray = python
        self.location.href = "uniwebview://downloadPyCode?direction=" + python
        // console.log('将当前python代码赋值给全局供调用：',window.pythoncode)
    }
    handleSendDebugToastToUnity() {
        let python = this.props.vm.getPythonByteArray();
        window.pythoncodeArray = python
        self.location.href = "uniwebview://runPyCode?direction=" + python
    }
    // 手机端 退出
    handleSendBackToastToUnity() {
        self.location.href = "uniwebview://back_notsave?direction=back"
        this.setState({
            show: !this.state.show
        })
    }
    // 手机端 退出并保存
    handleBackSaveToastToUnity() {
        let workspace = window.Blockly.getMainWorkspace();
        let xml = window.Blockly.Xml.workspaceToDom(workspace);
        let text = window.Blockly.Xml.domToText(xml)
        if (text.length > 71) {
            localStorage.setItem("projectData", text)
        } else {
            localStorage.setItem("projectData", null)
        }

        // 发送退出并保存通知
        self.location.href = "uniwebview://back_save?direction=back"
        this.setState({
            show: !this.state.show
        })
    }
    handleShowModal() {
        this.setState({
            show: !this.state.show
        })
    }
    handleM5ShowModal(){
        this.setState({
            M5_download_show: !this.state.M5_download_show
        })
    }
    handleM5Download(title){
        this.setState({
            M5_download_show: false
        })
        this.setDownloadType('python')
        this.props.vm.downProjectJson(title)
    }
    render() {
        const {
            vm, // eslint-disable-line no-unused-vars
            isStarted, // eslint-disable-line no-unused-vars
            projectRunning,
            onSetRunningStatus,
            isCorrect,
            ...props
        } = this.props;

        return (

            <BtnlistComponent
                {...props}
                active={projectRunning}
                onGreenFlagClick={this.handleGreenFlagClick}
                onStopAllClick={this.handleStopAllClick}
                debugPythonClick={this.handleDebugPythonClick}
                debugCClick={this.handleDebugCClick}
                downloadPython={this.handleDownloadPythonClick}
                downloadC={this.handleDownloadCClick}
                handleDownloadDesk={this.handleDownloadDesk}
                defaultDownload={this.handleDefaultDownloadClick}
                is_mobi={this.ScratchBlocks.getalls().is_mobi}
                sendPyCodeToWindow={this.handleSendPyCodeToWindowClick}
                sendDebugToastToUnity={this.handleSendDebugToastToUnity}
                sendBackToastToUnity={this.handleSendBackToastToUnity}
                backSaveToastToUnity={this.handleBackSaveToastToUnity}
                showModal={this.handleShowModal}
                show={this.state.show}
                M5_download_show={this.state.M5_download_show}
                handleM5Download={this.handleM5Download}
                handleM5ShowModal={this.handleM5ShowModal}
            />
        );
    }
}

Btnlist.propTypes = {
    debugPythonClick: PropTypes.func,
    debugCClick: PropTypes.func,
    downloadPython: PropTypes.func,
    downloadC: PropTypes.func,
    defaultDownload: PropTypes.func,
    isStarted: PropTypes.bool.isRequired,
    projectRunning: PropTypes.bool.isRequired,
    vm: PropTypes.instanceOf(VM)
};

const mapStateToProps = state => ({
    isStarted: state.scratchGui.vmStatus.running,
    projectRunning: state.scratchGui.vmStatus.running,
    // downloadPython: state.scratchGui.vm.downProjectJson.bind(state.scratchGui.vm),
    // downloadC: state.scratchGui.vm.downloadC.bind(state.scratchGui.vm, state.scratchGui.mode.linkMode),
    isRunPython: state.scratchGui.btnList.isRunPython,
    isRunC: state.scratchGui.btnList.isRunC,
    arg: state.scratchGui.mode.linkMode,
    isCorrect: state.scratchGui.projectTitle.isCorrect
});
// no-op function to prevent dispatch prop being passed to component
const mapDispatchToProps = (dispatch) => ({
    onSetRunningStatus: (type, status) => {
        // 首先判断是以python调试还是以c调试（即判断是E6M6需要改变图标还是C1)
        // 其次需要传入true或false给全局state中isRunC或isRunPython
        // 从而控制调试图标的变化
        if (type === 'python') {
            if (status) {
                dispatch(runPythonTrue());
            } else {
                dispatch(runPythonFalse());
            }
        } else if (type === 'c') {
            if (status) {
                dispatch(runCTrue());
            } else {
                dispatch(runCFalse());
            }
        } else if (type === 'all') {
            if (status) {
                dispatch(runPythonTrue());
                dispatch(runCTrue());
            } else {
                dispatch(runPythonFalse());
                dispatch(runCFalse());
            }
        }

    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Btnlist);
